import { defineStore } from "pinia";
import axiosClient from "../axios.js";

export const useGalleryStore = defineStore("gallery", {
    state: () => ({
        // ==================== states used on gallery page and its relation
        galleries: []
    }),
    getters: {
        // ==========
    },
    actions: {
        // ==================== actions used on gallery page and its relation
        async initGallery(){
            try{
                const response = await axiosClient.get(`gallery/category`);
                this.galleries = response.data.data;
                this.pushGallery();
                console.log(response)
            }catch(error){
                console.log(error);
            }
        },
        async pushGallery(){
            if(this.galleries){
                for(var i = 0; i < this.galleries.length; i++){
                    const response = await axiosClient.get(`gallery/category/` + this.galleries[i].slug);
                    this.galleries[i].contents = response.data.galleries;
                    console.log(response)
                }
            }
        }
    }
});